exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".announcement{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:1em;border-bottom:1px solid #d8e2e7;position:fixed;bottom:1em;z-index:100;width:70%;left:8%;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.15);box-shadow:0 2px 4px rgba(0,0,0,.15);background:#fafbff;color:#333;border-radius:2px;border:1px solid #f7f7f7;border-top:2px solid #5586d7;border-top-right-radius:2px;border-bottom-right-radius:2px}.announcement a{color:#333}.announcement .v-cancel{-ms-flex-preferred-size:65px;flex-basis:65px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3502a16c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Announcement.vue
// module id = ROQw
// module chunks = 0